<template>
    <!--Top Bar-->
    <TopBar msg="Welcome to Your Vue.js App" />

    <div class="category bg-background">

        <v-card elevation="0" rounded="0"
            class="bg-secondary mx-auto d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block" height="150">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="category-title-text">
                    Search Products
                </h1>
            </div>
        </v-card>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="100">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    Search Products
                </h1>
            </div>
        </v-card>

        <v-container>
            <v-row dense>
                <v-col cols="12" sm="12" md="12">
                    <!--Web View screen-->
                    <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-none d-sm-block d-md-block d-lg-block mt-n8"
                        max-width="1100">
                        <v-container>
                            <v-row dense no-gutters>
                                <v-col cols="1"></v-col>
                                <v-col cols="8" sm="12" md="12" lg="12">
                                    <v-sheet min-width="600" max-width="1150">
                                        <div class="d-sm-flex d-md-flex d-lg-flex flex-wrap justify-left bg-background">
                                            <ProductCard :products="productList" />
                                            <p v-if="productList.length == 0" class="mx-auto ma-10 text-h6"> No
                                                Products
                                                Found </p>
                                        </div>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <!--Web View Screen End-->

                    <!--Mobile View Tab screen-->
                    <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-block d-sm-none d-md-none d-lg-none mt-n8"
                        max-width="1100">
                        <v-row dense>
                            <v-col cols="12">
                                <v-sheet min-width="340" max-width="1100">
                                    <div
                                        class="d-flex d-sm-flex d-md-flex d-lg-flex flex-wrap align-content-left justify-left align-left bg-background">
                                        <ProductCard :products="productList" />
                                        <p v-if="productList.length == 0" class="mx-auto ma-10 text-h6"> No
                                            Products
                                            Found </p>
                                    </div>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!--Mobile View Tab screen End-->

                </v-col>
            </v-row>
        </v-container>

    </div>

    <AppFooter />
</template>

<style>
.category-title-text {
    font-size: 35px;
}

.mobile-category-title-text {
    font-size: 22px;
}
</style>

<script>
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'
import ProductCard from '@/components/Product.vue'
import AppFooter from '@/components/Footer.vue'
import { mapActions, mapGetters } from "vuex";
export default {
    name: 'SearchView',
    data: () => ({
        categoryTab: '',
    }),
    components: {
        TopBar,
        ProductCard,
        AppFooter,
    },
    created() {
        // // console.log(this.$route.params.id);
        // //console.log(this.$route.params.subid);
        // //category based product show when page open
        // this.getSubCategory(this.$route.params.id);
        // //this.tab = this.$route.params.subid;
        // this.categoryProduct(this.$route.params.subid);
        //router change show the products


        this.$watch(
            () => this.$route.params,
            () => {

                this.searchProduct(this.$route.params.name);
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )

        this.getlocationDetails();

    },
    computed: {
        ...mapGetters([
            "subCategoryList",
            "productList",
            "categoryDetails",
            "locationDetails",
        ]),
        categoryDetail: function () {
            return this.categoryDetails;
        }
    },
    methods: {
        ...mapActions([
            "getSubCategory",
            "getProduct",
            "getlocationDetails",
        ]),
        searchProduct(name) {
            var categoryId = ''
            var subCategoryId = '';

            const searchData = {
                categoryId: categoryId,
                subCategoryId: subCategoryId,
                search: name,
            };
            this.getProduct(searchData);
        },

    },
}
</script>
